var _polygon, _path, _path2, _rect, _path3, _rect2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricalSystem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 47.16",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "electrical"
  }, "Electrical System Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "electrical"
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "24.7 18.36 23.3 17.76 20.7 24.46 24.8 24.46 22.6 28.46 24 29.06 27.4 22.96 22.8 22.96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24 14.56a9 9 0 1 0 9 9 9 9 0 0 0 -9 -9zm7.6 9a7.6 7.6 0 1 1 -7.6 -7.56 7.53 7.53 0 0 1 7.6 7.56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48,37.26,43.7,34v-4.4H38.2V34L34,37.26v4.2h3v5.7h1.5v-5.7H44v5.7h1.5v-5.7H48Zm-8.2-2.4v-3.8h2.4v3.8l4.4,3.3v1.9H35.4v-1.9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.1,
    y: 36.96,
    width: 3.8,
    height: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6,17.56v-4.4l4.3-3.3V5.66h-3V0H9.4v5.7H3.9V0H2.4v5.7H0v4.2l4.3,3.3v4.4Zm-1.5-5.2v3.8H5.7v-3.8L1.3,9.06V7.16H12.5v1.9Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8.66,
    width: 3.8,
    height: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m38 12.56a7.39 7.39 0 0 1 2.2 5.7v8.8h-1.2v1.5h3.8v-1.5h-1.2v-8.9a9 9 0 0 0 -2.6 -6.8c-3-2.9-7.6-3-8.5-3.1h-11.4v1.5h11.5c0.1 0.1 4.7 0.1 7.4 2.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7,34.26a7.39,7.39,0,0,1-2.2-5.7v-8.8H8.7v-1.5H4.9v1.5H6.1v8.9a9,9,0,0,0,2.6,6.8c3,2.9,7.4,3.1,8.4,3.1H28.7v-1.5H17.1C17.1,37,12.5,37,9.7,34.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalSystem);
export default __webpack_public_path__ + "static/media/electrical-system.486a26966240a0f59d2684e0f3d59fe7.svg";
export { ForwardRef as ReactComponent };